<script>

</script>

<template>
  <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.266602 9.99998V6.05331C0.266602 0.959977 3.8666 -1.09336 8.2666 1.43998L11.6799 3.41331L15.0933 5.38664C19.4933 7.91998 19.4933 12.08 15.0933 14.6133L11.6799 16.5866L8.2666 18.56C3.8666 21.0933 0.266602 19.0133 0.266602 13.9466V9.99998Z" fill="#F0F1F4"/>
  </svg>
</template>

<style scoped>

</style>